import { useEffect } from 'react';

function useDestructor(func: Function) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => func(), []);
}

export default useDestructor;
